import request from './request'

// ==================== 认证 ====================
export const login = (data) => request.post('/auth/login', data)
export const setPassword = (data) => request.post('/auth/set-password', data)

// ==================== 任务 ====================
export const fetchTasks = () => request.get('/admin/tasks')
export const createTask = (data) => request.post('/admin/tasks', data)
export const updateTask = (id, data) => request.put(`/admin/tasks/${id}`, data)
export const deleteTask = (id) => request.delete(`/admin/tasks/${id}`)

// ==================== 员工 ====================
export const fetchEmployees = (params) => request.get('/employees/subordinates', { params })
export const searchEmployees = (params) => request.get('/employees/search', { params })
export const createEmployee = (data) => request.post('/admin/employees', data)
export const updateEmployee = (id, data) => request.put(`/admin/employees/${id}`, data)
export const deleteEmployee = (id) => request.delete(`/admin/employees/${id}`)
export const markResigned = (id, data) => request.post(`/admin/employees/${id}/resign`, data)
export const fetchResigned = () => request.get('/admin/resigned')
export const restoreEmployee = (id) => request.post(`/admin/employees/${id}/restore`)

// ==================== 行为库 ====================
export const fetchBehaviors = (params) => request.get('/behaviors/list', { params })
export const fetchBehaviorCategories = () => request.get('/behaviors/categories')
export const fetchObjectiveData = (id) => request.get(`/behaviors/${id}/objective-data`)
export const createBehavior = (data) => request.post('/admin/behaviors', data)
export const updateBehavior = (id, data) => request.put(`/admin/behaviors/${id}`, data)
export const toggleBehavior = (id) => request.post(`/admin/behaviors/${id}/toggle`)
export const createCategory = (data) => request.post('/admin/behaviors/categories', data)
export const updateCategory = (id, data) => request.put(`/admin/behaviors/categories/${id}`, data)
export const deleteCategory = (id) => request.delete(`/admin/behaviors/categories/${id}`)

// ==================== 评估 ====================
export const createEvaluation = (data) => request.post('/evaluations', data)
export const answerQuestion = (id, data) => request.post(`/evaluations/${id}/answer`, data)
export const submitEvaluation = (id, data) => request.post(`/evaluations/${id}/submit`, data)
export const fetchEvaluationHistory = (params) => request.get('/evaluations/history', { params })
export const fetchEvaluationTrend = (id) => request.get(`/evaluations/trend/${id}`)
export const fetchAdminEvaluations = (params) => request.get('/admin/evaluations', { params })

// ==================== 数据看板 ====================
export const fetchHeatmap = (params) => request.get('/dashboard/heatmap', { params })
export const fetchABCompare = (params) => request.get('/dashboard/ab-compare', { params })

// ==================== 调研 ====================
export const createSurvey = (data) => request.post('/surveys', data)
export const fetchSurveys = () => request.get('/admin/surveys')
export const fetchSurveyResponses = () => request.get('/admin/survey-responses')
export const getSurveyDetail = (token) => request.get(`/surveys/${token}`)

// ==================== 离职反馈 ====================
export const fetchDepartureFeedbacks = () => request.get('/admin/departure-feedbacks')
export const createDepartureFeedback = (data) => request.post('/admin/departure-feedbacks', data)

// ==================== 调研题目配置 ====================
export const fetchSurveyQuestions = (params) => request.get('/admin/survey-questions', { params })
export const createSurveyQuestion = (data) => request.post('/admin/survey-questions', data)
export const updateSurveyQuestion = (id, data) => request.put(`/admin/survey-questions/${id}`, data)
export const deleteSurveyQuestion = (id) => request.delete(`/admin/survey-questions/${id}`)
export const exportSurveyQuestions = (params) => request.get('/admin/survey-questions/export', { params })
export const importSurveyQuestions = (data) => request.post('/admin/survey-questions/import', data)
export const fetchSurveyQuestionsPublic = (token) => request.get(`/surveys/${token}/questions`)

// ==================== 评估说明 ====================
export const fetchInstructions = (params) => request.get('/admin/instructions', { params })
export const createInstruction = (data) => request.post('/admin/instructions', data)
export const updateInstruction = (id, data) => request.put(`/admin/instructions/${id}`, data)
export const deleteInstruction = (id) => request.delete(`/admin/instructions/${id}`)
export const toggleInstruction = (id) => request.post(`/admin/instructions/${id}/toggle`)
export const setActiveInstruction = (id) => request.post(`/admin/instructions/${id}/set-active`)

// ==================== 评估记录 ====================
export const deleteEvaluation = (id) => request.delete(`/admin/evaluations/${id}`)

// ==================== 内容管理（建议/案例/课程） ====================
export const fetchContents = (params) => request.get('/admin/contents', { params })
export const createContent = (data) => request.post('/admin/contents', data)
export const updateContent = (id, data) => request.put(`/admin/contents/${id}`, data)
export const deleteContent = (id) => request.delete(`/admin/contents/${id}`)

// ==================== 管理员 ====================
export const fetchAdmins = () => request.get('/admin/admins')
export const createAdmin = (data) => request.post('/admin/admins', data)
export const updateAdmin = (id, data) => request.put(`/admin/admins/${id}`, data)
export const deleteAdmin = (id) => request.delete(`/admin/admins/${id}`)

// ==================== 系统配置 ====================
export const fetchSettings = (params) => request.get('/admin/settings', { params })
export const updateSetting = (data) => request.post('/admin/settings', data)
export const fetchActiveInstruction = (params) => request.get('/instructions/active', { params })
export const fetchScoringRules = (params) => request.get('/admin/scoring-rules', { params })

// ==================== AI 报告模块配置 ====================
export const fetchAiReportModules = (params) => request.get('/admin/ai-report-modules', { params })
export const updateAiReportModules = (data) => request.post('/admin/ai-report-modules', data)

// ==================== 话术模板 ====================
export const fetchTemplates = (params) => request.get('/admin/templates', { params })
export const createTemplate = (data) => request.post('/admin/templates', data)
export const updateTemplate = (id, data) => request.put(`/admin/templates/${id}`, data)
export const deleteTemplate = (id) => request.delete(`/admin/templates/${id}`)
